import TranslateCartas from "@/views/admin/translate/TranslateCartas";

export default {
  path: "translate/cartas",
  name: "TranslateCartas",
  component: TranslateCartas,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
